import React, {useState, useEffect, createContext} from 'react';
import { useSearchParams } from 'react-router-dom';
import ReactGA from "react-ga4";
import InfiniteScroll from 'react-infinite-scroller';
import VideoDisplayCard from './Components/VideoDisplayCard';
import VideoListFilter from './Components/VideoListFilter';
import { PageHeader, Drawer, Button, Typography, Row, Col } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { YouTubePlayer } from 'react-youtube';

const { Paragraph } = Typography;


type PlayerContextType = {
  setGlobalPlayer: (value: any) => void;
  globalPlayer: YouTubePlayer;
}

export const PlayerContext = createContext<PlayerContextType>({} as PlayerContextType);


function VideoList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  const [globalPlayer, setGlobalPlayer] = useState();
  const [loadedNum, setLoadedNum] = useState(6);
  const [hasMore, setHasMore] = useState(true);
  const [l, setL] = useState<any[]>([]);
  const [channels, setChannels] = useState<{ [key: string]: any }>({});
  const [videos, setVideos] = useState<any>([]);


  useEffect(() => {
    (async ()=> {
      const [channelList, videoList] = await Promise.all([
        fetch(process.env.REACT_APP_DATA_PATH + 'channel_list.json', {method: 'GET'}).then(res => res.json()),
        fetch(process.env.REACT_APP_DATA_PATH + 'video_list.json', {method: 'GET'}).then(res => res.json())
      ]);

      let initVideos: { [key: string]: any }[]
      // channelsでフィルター
      const idxs: string[] = searchParams.getAll('channels');
      const initChannels: { [key: string]: any } = {};
      const filterdChannelIds: string[] = [];
      for (const c of channelList) {
        initChannels[c.channelId] = c
        if (idxs.length === 0 || idxs.includes(c.idx)){
          filterdChannelIds.push(c.channelId);
        }
      }
      setChannels(initChannels);
      initVideos = videoList.filter(
        (item: { [key: string]: any })  => filterdChannelIds.includes(item.channelId)
      )

      // titleFiltersでフィルター
      const andOr: string | null = searchParams.get('andOr');
      const titleFilters: string[] = searchParams.getAll('titleFilters');
      if (andOr === 'or'){
        initVideos = initVideos.filter(
          (item: { [key: string]: any })  => (titleFilters.some(str => item.title.includes(str)))
        )
      } else {
        for (const titleFilter of titleFilters) {
          initVideos = initVideos.filter(
            (item: { [key: string]: any })  => (item.title.indexOf(titleFilter) > -1)
          )
        }
      }


      // scheduledStartTimeでソート
      const sortedVideoList = initVideos.sort((first:any, second:any) => {
        const firstDate = first.scheduledStartTime? new Date(first.scheduledStartTime): new Date(0);
        const secondDate = second.scheduledStartTime ? new Date(second.scheduledStartTime) : new Date(0);;
        return secondDate.getTime() - firstDate.getTime();
      });
      setVideos(sortedVideoList);
      setL(sortedVideoList.slice(0,loadedNum))
    })()
},[])

  useEffect(() => {
    if(process.env.REACT_APP_REACT_GA){
      ReactGA.initialize(process.env.REACT_APP_REACT_GA as string);
      ReactGA.send({
        hitType: "pageview",
        page: '/hololive/VideoList',
      });
    }
  },[]);

  const loadMore = () => {
    const newLoadNum = loadedNum + 6;
    setLoadedNum(newLoadNum);
    setHasMore(newLoadNum < videos.length)
    setL(videos.slice(0,newLoadNum))
  }

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <div className="VideoList">
      <PageHeader
        title="えこリク分析α"
        subTitle="最近のホロメンの見どころ分析 - 一覧ページ"
      >
        <Paragraph>
          あなたの推し活を手助けするホロライブ動画分析サイトです。HololiveのYoutube動画の見どころを分析してグラフ化しています。"見どころグラフを開く"ボタンからグラフを表示してください。グラフ頂点をクリックすると対応した動画の時刻にジャンプできます。
        </Paragraph>
        <Paragraph>
          ※分析未完了の動画は"見どころグラフを開く"ボタンが無効化されています。
        </Paragraph>

        <Button type="primary" onClick={showDrawer}>
          フィルターを設定する
        </Button>
      </PageHeader>
      
      {videos.length === 0 || Object.keys(channels).length === 0 
      ? <Row key="InfiniteScrollloader" justify="center">
          <LoadingOutlined style={{verticalAlign: 'middle',}}/>loading
        </Row> 
      : <InfiniteScroll
          loadMore={loadMore}
          hasMore={hasMore} 
          loader={<Row key="InfiniteScrollloader" justify="center"><LoadingOutlined style={{verticalAlign: 'middle',}}/>loading</Row>}
          useWindow={true}
        >
          <PlayerContext.Provider value={{globalPlayer, setGlobalPlayer}}>
            <Row>
              {l.map((item, idx) => {
                if(!channels.hasOwnProperty(item.channelId)){
                  console.log(`chennelId is not found. videoId: ${item.videoId}, channelId: ${item.channelId}` )
                  return ''
                }
                return (
                  <Col xs={24} md={12} xl={8} key={'VideoListCol_' + idx + '_' + item.videoId}>
                    <VideoDisplayCard
                      videoId={item.videoId}
                      title={item.title}
                      publishedAt={item.publishedAt}
                      scheduledStartTime={item.scheduledStartTime}
                      description={item.description}
                      thumbnail={item.thumbnail}
                      channel={channels[item.channelId]}
                      hasResults={item.hasResults}
                    />
                  </Col>
                );
              })}
            </Row>
          </PlayerContext.Provider>
        </InfiniteScroll>
      }

      <Drawer title="フィルターを設定する" placement="right" onClose={onClose} open={open}>
        <VideoListFilter channels={channels}/>
      </Drawer>
    </div>
  );
}

export default VideoList;
